import styled from "@emotion/styled"
import SectionWrapper from "../../components/section-wrapper/section-wrapper.component"
import { Container } from "@mui/material"
import CustomBgImage from "../../components/custom-bg-image/custom-bg-image.component"
import CustomImage from "../../components/custom-image/custom-image.component"

export const Section = styled(SectionWrapper)`
  padding-top: 0;
  padding-bottom: 0;
  width: 100%;
  overflow: hidden;
  height: 810px;

  ${({ theme }) => theme.breakpoints.up("md")} {
    border-radius: 0px 0px 40px 40px;
  }
`

export const Wrapper = styled(Container)`
  margin-top: ${({ theme }) => theme.typography.pxToRem(200)};
  position: relative;
`

export const BgImage = styled(CustomBgImage)`
  position: relative;
  height: 810px;
`

export const Title = styled.div`
  p {
    color: ${({ theme }) => theme.palette.primary.dark};
    font-size: ${({ theme }) => theme.typography.pxToRem(44)};
    font-style: normal;
    font-weight: 500;
    line-height: ${({ theme }) => theme.typography.pxToRem(52)};
    max-width: 569px;

    ${({ theme }) => theme.breakpoints.down("md")} {
      font-size: ${({ theme }) => theme.typography.pxToRem(32)};
      line-height: ${({ theme }) => theme.typography.pxToRem(40)};
      font-weight: 500;
    }
  }

  span {
    color: ${({ theme }) => theme.palette.secondary.main};
  }

  ${({ theme }) => theme.breakpoints.down("md")} {
    p {
      font-size: ${({ theme }) => theme.typography.pxToRem(32)};
      line-height: ${({ theme }) => theme.typography.pxToRem(40)};
    }
  }
`

export const LeftImage = styled(CustomImage)`
  position: absolute;
  bottom: -10px;
  left: 20%;
`
export const RightImage = styled(CustomImage)`
  position: absolute;
  right: 22%;
  bottom: -10px;

  ${({ theme }) => theme.breakpoints.down("md")} {
    right: 0;
  }
`
